import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Home, Login, Shop, Profile, Guide, Basket, NotFound } from "./pages";
import "./App.css";
import AuthOutlet from "@auth-kit/react-router/AuthOutlet";
import { CartProvider } from "./hooks/useCartContext";
import { SelectionProvider } from "./hooks/useSelectionContext";
import { ChakraProvider } from "@chakra-ui/react";
import { customTheme } from "./resources";
import { Dashboard } from "./pages/dashboard/Dashboard";
import { Templates } from "./pages/templates/Templates";
import { Feedback } from "./pages/feedback/Feedback";
import { HomePageGuide } from "./pages/guide/HomePageGuide";
import { ShopPageGuide } from "./pages/guide/ShopPageGuide";
import { TemplatePageGuide } from "./pages/guide/TemplatePageGuide";
import { ResultPageGuide } from "./pages/guide/ResultPageGuide";
import { CartPageGuide } from "./pages/guide/CartPageGuide";
// import BrowserPage from "./pages/BrowserPage";
import { useState, useEffect } from "react";
import { NotificationModal } from "./components/NotificationModal";

function AppInner() {
  const location = useLocation();
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get("notification") === "true") {
      setIsNotificationModalOpen(true);
    }

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data && event.data.type === "notification-click") {
          setIsNotificationModalOpen(true);
        }
      });
    }
  }, [location.search]);

  // function checkIfStandalone() {
  //   return window.matchMedia("(display-mode: standalone)").matches;
  // }
  const isMobile = window.innerWidth < 500;
  // const isStandalone = checkIfStandalone();
  if (!isMobile) {
    return (
      <div className="mobileMessage">
        <h1 style={{ fontWeight: "bold", fontSize: 36 }}>Hi !</h1>
        <h1>This app was designed for mobile use</h1>
        <p>Open it on your mobile device to enjoy the experience.</p>
      </div>
    );
  }
  // if (!isStandalone) return <BrowserPage />;
  return (
    <ChakraProvider theme={customTheme}>
      <SelectionProvider>
        <CartProvider>
          <Routes>
            <Route element={<AuthOutlet fallbackPath="login" />}>
              <Route path="/" element={<Home />}>
                <Route index element={<Dashboard />} />
                <Route path="shop" element={<Shop />} />
                <Route path="profile" element={<Profile />} />
                <Route path="basket" element={<Basket />} />
                <Route path="templates" element={<Templates />} />
                <Route path="feedback" element={<Feedback />} />
                <Route path="guide">
                  <Route index element={<Guide />} />
                  <Route path="home" element={<HomePageGuide />} />
                  <Route path="shop" element={<ShopPageGuide />} />
                  <Route path="template" element={<TemplatePageGuide />} />
                  <Route path="results" element={<ResultPageGuide />} />
                  <Route path="cart" element={<CartPageGuide />} />
                </Route>
              </Route>
            </Route>
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Login />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <NotificationModal
            isOpen={isNotificationModalOpen}
            onClose={() => setIsNotificationModalOpen(false)}
          />
        </CartProvider>
      </SelectionProvider>
    </ChakraProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;
